import gql from 'graphql-tag';

export default gql`
    mutation DeleteLoads($input: DeleteLoadsInput) {
        deleteLoads(input: $input) {
            errors
        }
    }
`;
